import { render, staticRenderFns } from "./contentTemplate.vue?vue&type=template&id=6879b74a&"
import script from "./contentTemplate.vue?vue&type=script&lang=js&"
export * from "./contentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports